import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/partner')({
  component: () => (
    <RoutePlaceholder icon="providers" title="Partners" description="Affiliate landing surface." />
  ),
});
